import { Component, Input } from "@angular/core";

@Component({
  selector: "search-bar",
  templateUrl: "./admin-search.component.html",
  styleUrls: ["../../admin-breadcrumb.component.css"],
})
export class AdminSearchbarComponent {
  showsearchbar: boolean = false;
  @Input("search") search;
  constructor() {}


  showSearch() {
    this.showsearchbar = true;
  }
}
